import Grid from '@mui/material/GridLegacy';
import React from 'react';
import { IconCard } from '../IconCard';
import type { IconCardsCollectionProps } from './IconCardsCollection.types';

export const IconCardsCollectionComponent: React.FC<
  IconCardsCollectionProps
> = ({ model }) => {
  return (
    <Grid mb={4} container spacing={5}>
      {model?.items?.map(
        (card) => card && <IconCard card={card} key={card.documentId} />
      )}
    </Grid>
  );
};
